/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-var */

if (
  import.meta.env.SSR ||
  (import.meta.env.DEV && !import.meta.env.VITE_ENABLE_POSTHOG)
) {
  console.log(
    "[app] PostHog initialization is disabled in development mode. Skipping setup."
  );
  (globalThis as any).posthog = {
    init: () => {},
    capture: () => {},
    onFeatureFlags: () => {},
    identify: () => {},
    setPersonProperties: () => {},
    register_for_session: () => {},
    unregister_for_session: () => {},
  };
} else {
  console.log("[app] Initializing PostHog for error reporting...");

  // @ts-ignore
  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      // @ts-ignore
      (window.posthog && window.posthog.__loaded) ||
      // @ts-ignore
      ((window.posthog = e),
      (e._i = []),
      // @ts-ignore
      (e.init = function (i, s, a) {
        // @ts-ignore
        function g(t, e) {
          var o = e.split(".");
          (2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
            }));
        }
        (((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src =
            s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
            "/static/array.js"),
          // @ts-ignore
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(
            p,
            // @ts-ignore
            r
          ));
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            // @ts-ignore
            u.toString = function (t) {
              var e = "posthog";
              return (
                "posthog" !== a && (e += "." + a),
                t || (e += " (stub)"),
                e
              );
            },
            u.people.toString = function () {
              return u.toString(1) + ".people (stub)";
            },
            o =
              "init capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug".split(
                " "
              ),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
    // @ts-ignore
  })(document, window.posthog || []);

  const seedBibleApiKey = "phc_rEUogfrnXkdTitOTrfWK2laEINF1QwNtGNQizzuMW0";
  posthog.init(seedBibleApiKey, {
    api_host: "https://i.seedbible.org",
    ui_host: "https://us.posthog.com",
    defaults: "2026-05-30",
  });

  posthog.register({});
}
